module.exports = __webpack_public_path__ + "static/media/Piercing-mascintimate-princealbert.3b0ce291.png";